/**
 * Libs
 */
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React, { useMemo } from 'react';
import withUniverseVerification from 'src/HOCs/withUniverseVerification';

/**
 * Components
 */
import PageMeta from 'src/components/organisms/page-meta';

/**
 * Constants
 */
import { PAGES_LOCALES } from 'src/constants/common.constants';
import { FaqContainer } from 'src/features/common/faq/containers/faq-container';
import { FaqContainer as NFaqContainer } from 'src/features/white-labels/nftsuperlab/faq/containers/faq-container';
import { FaqContainer as OFaqContainer } from 'src/features/white-labels/ocean/faq/containers/faq-container';
import { FaqContainer as SMFaqContainer } from 'src/features/white-labels/thesportmuseum/faq/containers/faq-container';
import { FaqContainer as WFaqContainer } from 'src/features/white-labels/worldofartists/faq/containers/faq-container';
import { useGetUniverseTemplate } from 'src/hooks/use-get-universe-template';

interface IFAQPageLocale {
    title: string;
}

const componentTestId = 'faq-page';

const FAQPage = () => {
    const { t } = useTranslation(['pages']);
    const { isOceanTemplate, isNftSuperlab, isWorldOfArtists, isSportsMuseumTemplate } = useGetUniverseTemplate();

    const getLayout = () => {
        if (isOceanTemplate) {
            return <OFaqContainer data-test-id={`${componentTestId}-root`} />;
        }
        if (isNftSuperlab) {
            return <NFaqContainer data-test-id={`${componentTestId}-root`} />;
        }
        if (isWorldOfArtists) {
            return <WFaqContainer data-test-id={`${componentTestId}-root`} />;
        }
        if (isSportsMuseumTemplate) {
            return <SMFaqContainer data-test-id={`${componentTestId}-root`} />;
        }

        return <FaqContainer data-test-id={`${componentTestId}-root`} />;
    };

    const locale: IFAQPageLocale = useMemo(
        () => ({
            title: t('faq.title', { ns: 'pages' }),
        }),
        [t]
    );

    return (
        <>
            <PageMeta title={locale.title} />
            {getLayout()}
        </>
    );
};

// @ts-ignore
export async function getServerSideProps({ locale }) {
    return {
        props: {
            ...(await serverSideTranslations(locale, PAGES_LOCALES)),
        },
    };
}

export default withUniverseVerification(FAQPage);